module.exports = __webpack_public_path__ + "img/pending.ad9f1748.png";